<template>
  <div class="vm-card host" :class="classes">
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    vmRaised: {
      type: Boolean,
      default: false
    },
    vmStroked: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    classes() {
      return {
        'vm-raised': this.vmRaised,
        'vm-stroked': this.vmStroked
      };
    }
  }
};
</script>

<style scoped>
.host.vm-card {
  border-radius: 4px;
  background-color: #fff;
}
.host.vm-card.vm-raised {
  box-shadow: 0 2px 1px -1px rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.14),
    0 1px 3px 0 rgba(0, 0, 0, 0.12);
}
.host.vm-card.vm-stroked {
  border: 1px solid #dfdfdf;
}
</style>
